"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
var Error_1 = __importDefault(require("@material-ui/icons/Error"));
var Info_1 = __importDefault(require("@material-ui/icons/Info"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var colors_1 = require("@material-ui/core/colors");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
var SnackbarContent_1 = __importDefault(require("@material-ui/core/SnackbarContent"));
var Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
var styles_1 = require("@material-ui/core/styles");
var variantIcon = {
    success: CheckCircle_1.default,
    warning: Warning_1.default,
    error: Error_1.default,
    info: Info_1.default,
};
var useStyles1 = (0, styles_1.makeStyles)(function (theme) { return ({
    success: {
        backgroundColor: colors_1.green[600],
    },
    error: {
        backgroundColor: colors_1.red[500],
    },
    info: {
        backgroundColor: colors_1.blue[500],
    },
    warning: {
        backgroundColor: colors_1.amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
}); });
function MySnackbarContentWrapper(props) {
    var classes = useStyles1({});
    var className = props.className, message = props.message, onClose = props.onClose, variant = props.variant, other = __rest(props, ["className", "message", "onClose", "variant"]);
    var Icon = variantIcon[variant];
    return (React.createElement(SnackbarContent_1.default, __assign({ className: (0, clsx_1.default)(classes[variant], className), "aria-describedby": "client-snackbar", message: React.createElement("span", { id: "client-snackbar", className: classes.message },
            React.createElement(Icon, { className: (0, clsx_1.default)(classes.icon, classes.iconVariant) }),
            message), action: [
            React.createElement(IconButton_1.default, { key: "close", "aria-label": "close", color: "inherit", onClick: onClose },
                React.createElement(Close_1.default, { className: classes.icon })),
        ] }, other)));
}
var useStyles2 = (0, styles_1.makeStyles)(function (theme) { return ({
    margin: {
        margin: theme.spacing(1),
    },
}); });
function CustomizedSnackbars(props) {
    var classes = useStyles2({});
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(3000), autoHideTime = _b[0], setAutoHideTime = _b[1];
    React.useEffect(function () {
        if (props.short) {
            setAutoHideTime(3000);
        }
        else if (props.medium) {
            setAutoHideTime(6000);
        }
        else if (props.long) {
            setAutoHideTime(10000);
        }
        else if (props.longer) {
            setAutoHideTime(15000);
        }
        else if (props.toolong) {
            setAutoHideTime(20000);
        }
    }, []);
    function handleClick() {
        setOpen(true);
    }
    function handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    }
    return (React.createElement("div", null,
        React.createElement(Snackbar_1.default, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, disableWindowBlurListener: true, open: props.open, autoHideDuration: autoHideTime, onClose: props.onClose },
            React.createElement(MySnackbarContentWrapper, { onClose: props.onClose, variant: props.variant, message: props.message }))));
}
exports.default = CustomizedSnackbars;
//# sourceMappingURL=Snack.js.map